import searchBar from './actions/searchBar';
import searchPage from './actions/searchPage';
import generalActions from './actions/general';
export default function products() {
  searchBar();
  searchPage();
  generalActions();
}


// WEBPACK FOOTER //
// ./source/scripts/products/main.js